export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;
export const PASSWORD_CHARACTER_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;

export const getPasswordRequirements = (password: string) => ({
    length: password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    digit: /\d/.test(password),
});
